import React, { useContext } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { FieldArray } from "formik";
import AddIcon from "@mui/icons-material/Add";
import MapIcon from "@material-ui/icons/Map";

import { useFieldResourceStyles } from "../useFieldResourceStyles";
import { tokens } from "../../../../theme/tokens";
import BottomDrawer from "../../../shared/BottomDrawer";
import { Typography } from "@mui/material";
import FieldResourceCoverageMap from "../../../FieldResourceView/Map";
import { StoreContext } from "../../../../context/StoreContext";

import { useGlobalStyles } from "../../../shared/helpers/GlobalStyles";

const SectionHeader: React.FC = () => {
  const classes = useFieldResourceStyles();
  const globalClasses = useGlobalStyles();
  const [mapOpen, setMapOpen] = React.useState(false);
  const { fieldResources } = useContext(StoreContext);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <h5 className={classes.tabHeading}>Field Resource Information</h5>
      <span style={{ gap: "8px", display: "flex" }}>
        {fieldResources && fieldResources.length > 0 && (
          <IconButton className={globalClasses.iconButton}>
            <MapIcon
              style={
                mapOpen
                  ? { color: tokens.color.text.primary }
                  : { color: tokens.color.text.secondary }
              }
              onClick={() => {
                setMapOpen(!mapOpen);
              }}
            />
          </IconButton>
        )}
        <Tooltip title="Add new field resource">
          <FieldArray name="case_detail.case_details.field_resource_information">
            {({ push }) => (
              <IconButton
                className={globalClasses.iconButton}
                onClick={() => {
                  push({
                    id: "",
                    date_hired: "",
                    due_date: "",
                    hours_authorized: 0,
                    hours_billed: 0,
                    miles_billed: 0,
                    database_billed: 0,
                    report_received_date: "",
                    invoice_received_date: "",
                    invoice_approved_date: "",
                    rating: 0,
                    type: "",
                  });
                }}
              >
                <AddIcon style={{}} />
              </IconButton>
            )}
          </FieldArray>
        </Tooltip>
      </span>
      <BottomDrawer
        open={mapOpen}
        onClose={() => setMapOpen(false)}
        title={
          <Typography variant="h6" style={{ fontWeight: 600 }}>
            Field Resource Coverage Map
          </Typography>
        }
      >
        <FieldResourceCoverageMap fieldResourceList={fieldResources} />
      </BottomDrawer>
    </div>
  );
};

export default SectionHeader;
